var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.786,
    height: 15,
    viewBox: "0 0 11.786 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33",
    "data-name": "Layer 33",
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67647",
    "data-name": "Path 67647",
    d: "M9.821,3.607V15.393A1.607,1.607,0,0,1,8.214,17H6.607A1.607,1.607,0,0,1,5,15.393V3.607A1.607,1.607,0,0,1,6.607,2H8.214A1.607,1.607,0,0,1,9.821,3.607ZM15.179,2H13.571a1.607,1.607,0,0,0-1.607,1.607V15.393A1.607,1.607,0,0,0,13.571,17h1.607a1.607,1.607,0,0,0,1.607-1.607V3.607A1.607,1.607,0,0,0,15.179,2Z",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.f2a767e3708aa65a231859e3a2b2b08e.svg";
export { ForwardRef as ReactComponent };